export const filterMenuByPermissions = (menuData, userPermissions) => {
    return menuData
        .map((category) => {
            const filteredLinks = category.links.filter((link) => {
                if (link.public) {
                    return true;
                }
                const permissions = link.permission
                    ? Array.isArray(link.permission)
                        ? link.permission
                        : [link.permission]
                    : [];
                if (permissions.length === 0 || !link.actions) {
                    return false;
                }
                return permissions.some((permission) => {
                    const userPermission = userPermissions[permission];
                    return userPermission && link.actions.some((action) => userPermission[action]);
                });
            });

            return filteredLinks.length > 0 ? { ...category, links: filteredLinks } : null;
        })
        .filter(Boolean);
};
